export default __webpack_public_path__ + "static/media/ls-quality-losses.8eca5610.svg";